import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { StringId } from '../components/localizer/localizer'
import { Logger, fillValues, RequestContext } from '@utils'

export type DVStringAttrs = { [key: string]: { [key: string]: string } }

export type IGetString = ReturnType<typeof buildGetString>
export const buildGetString = (
  strings: Partial<Record<StringId, string>>,
  logger: Logger,
  context: RequestContext
) => {
  let errorCount = 0
  return (stringId: StringId, replace?: { [key: string]: string }) => {
    const stringTemplate = strings[stringId]
    if (!stringTemplate) {
      //At most 1 error per widget to avoid flooding CSM when getStrings fails
      errorCount === 0 && logger.error(`Missing string ${stringId}`)
      errorCount += 1
      return context.isInternal ? `MISSING STRING ${stringId}` : ''
    }
    return fillValues(stringTemplate, replace, logger)
  }
}

export const buildDvString = (string: string, attrs: DVStringAttrs = {}) => ({
  string,
  attrs,
})

export const convertToDVString = (
  s: string | WpsRuntime.atv.wps.DVString
): WpsRuntime.atv.wps.DVString => {
  if (typeof s === 'string') {
    return buildDvString(s.trim()) as WpsRuntime.atv.wps.DVString
  } else {
    return s
  }
}

export const removeDVStringLinebreaks = (
  dvString: WpsRuntime.atv.wps.DVString
): WpsRuntime.atv.wps.DVString => {
  return (
    dvString && {
      ...dvString,
      string:
        dvString.string && dvString.string.replace(/\{lineBreak\}/gi, ' '),
    }
  )
}
